// Redux Action Types
import { SET_DRAWER } from '../actions/types';
// Initial State
const initialState = false;

export default function (state = initialState, action) {
  if (action.type === SET_DRAWER) return action.payload;
  return state;
}
